import React, { ChangeEvent } from "react";

interface IFileSelect {
  id: string;
  isMultiple: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const FileSelect = React.forwardRef<HTMLInputElement, IFileSelect>(
  ({ id, isMultiple, onChange }, ref) => (
    <input
      ref={ref}
      id={id}
      data-testid={id}
      style={{ display: "none" }}
      type="file"
      multiple={isMultiple}
      onChange={onChange}
    />
  )
);

export default FileSelect;
